var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecharge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35 33.2671V181.277L112.93 220.457V72.447L45.35 33.2671ZM105.16 129.077L52.3799 98.5969V55.0669L105.16 85.5371V129.077Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.82 59.407L68.23 20.2271L45.34 33.2871L112.92 72.467L135.81 59.407H135.82Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.82 59.4072C128.2 63.7572 120.55 68.1123 112.93 72.4623L112.93 220.472L135.32 207.417L135.82 59.4072Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 207.522L202.23 200.422L204.66 201.882L192.37 208.982L189.94 207.522Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.8 202.952L194.1 195.862L196.53 197.312L184.23 204.412L181.8 202.952Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.95 212.593L177.2 206.402L177.15 212.562L187.9 218.762L187.95 212.593Z",
    fill: "#72D09A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4399 135.092L66.5299 152.872L75.2299 157.972L74.7199 174.652L86.1599 157.652C83.1499 155.822 80.1199 154.022 77.1099 152.202C77.2099 146.472 77.3299 140.782 77.4299 135.092H77.4399Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.23 222.052C152.43 214.062 138.64 206.062 124.84 198.072L119.48 201.172C133.27 209.192 147.07 217.202 160.86 225.222C162.65 224.162 164.44 223.112 166.23 222.052Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.73 205.882L204.66 201.882V206.212L201.43 208.022L197.73 205.882Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M189.59 201.312L196.53 197.322V201.642L193.29 203.452L189.59 201.312Z",
    fill: "#B2E8C5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M160.86 225.222C147.07 217.202 133.27 209.192 119.48 201.172V207.352C133.27 215.372 147.07 223.402 160.86 231.422V225.222Z",
    fill: "#72D09A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.67 203.482L160.86 218.962V225.222C169.13 220.572 177.39 215.922 185.66 211.282C186.33 208.682 187.01 206.082 187.68 203.482H187.67Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.57 197.122L177.21 206.402L187.93 212.592L204.01 209.502L182.56 197.122H182.57Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.01 209.502L187.93 212.593L187.88 218.762L203.96 215.662L204.01 209.502Z",
    fill: "#B2E8C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.65 211.282C177.38 215.932 169.12 220.582 160.85 225.222V231.422L185.65 216.952C185.65 215.062 185.65 213.172 185.65 211.282Z",
    fill: "#B2E8C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.65 211.282C177.38 215.932 169.12 220.582 160.85 225.222V231.422C169.1 226.762 177.34 222.092 185.59 217.432C185.61 215.382 185.63 213.332 185.64 211.282H185.65Z",
    fill: "#B2E8C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.56 224.152L160.94 223.712L160.56 224.152Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.fa27235265cd9ce0be221e0c222e696b.svg";
export { ForwardRef as ReactComponent };